import { __assign } from 'tslib';
import pino from 'pino';

var createLogger = function (_a) {
    var name = _a.name, _b = _a.context, context = _b === void 0 ? {} : _b, _c = _a.logLevel, logLevel = _c === void 0 ? 'info' : _c, _d = _a.logger, logger = _d === void 0 ? pino : _d;
    // set the log level to debug if we're in debug mode, or use the passed in logLevel or default value
    var level = logLevel;
    return logger({ level: level }).child(__assign({ name: name }, context));
};

export { createLogger };
